import { Box, Typography, Button } from "@mui/material";

export default function SuccessPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f0f9f0",
        textAlign: "center",
        px: 2,
      }}
    >
      <img
        src="https://sport-rex.com/wp-content/uploads/2024/04/websitelogo2.png"
        alt="REx Logo"
        style={{ width: "150px", marginBottom: "16px" }}
      />

      <Typography variant="h4" color="primary" gutterBottom>
        🎉 Registration Successful!
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Thank you for registering for REx’s National Day Race in Safwa.  
        We look forward to seeing you on **September 23, 2025 at 4:00 PM** 🎽
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={() => (window.location.href = "https://sport-rex.com/")}
      >
        Go to Homepage
      </Button>
    </Box>
  );
}
